import { httpsCallable } from "firebase/functions";
import { functions } from "./firebase";

/**
 * BillingService — Serviços para gerenciar o faturamento e faturas do Tenant.
 */
const BillingService = {
    /**
     * Cadastra o cartão de crédito do tenant para faturamento recorrente
     * @param {string} token - Token do cartão gerado pelo Mercado Pago Brick
     * @param {string} paymentMethodId - ID do meio de pagamento (ex: 'visa')
     */
    registerTenantCard: async (token, paymentMethodId) => {
        const fn = httpsCallable(functions, "registerTenantCard");
        const result = await fn({ token, paymentMethodId });
        return result.data;
    },

    /**
     * Atualiza a preferência de faturamento do tenant (Pix ou Boleto)
     * @param {string} method - 'pix' ou 'boleto'
     */
    updateTenantBillingMethod: async (method) => {
        const fn = httpsCallable(functions, "updateTenantBillingMethod");
        const result = await fn({ method });
        return result.data;
    },

    /**
     * Busca o histórico de faturas/checkout sessions do tenant
     */
    getTenantBillingInvoices: async () => {
        const fn = httpsCallable(functions, "getTenantBillingInvoices");
        const result = await fn();
        return result.data;
    }
};

export default BillingService;
